<template lang="pug">
.vendor-upload-quotation(v-loading="loading")
  title-bar {{ $t('项目信息') }}
    .btn_hangeStatus(@click="changeStatus" v-if="alreadyHasQuotation && sowInfo.can_edit")
      i.iconfont.icon-chucun(v-if="isEdit")
      i.iconfont.icon-bianji(v-else)
  .info-display(style="margin-left: 20px")
    el-row(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('名称') }}
        .info_content {{ sowInfo.sub_final_scope_name }}
    el-row(:gutter="20" v-if="sowInfo.spotplan_path")
      el-col(:span="24")
        .info_label {{ $t('附件') }}
        .info_content
          a(
            v-if="sowInfo.spotplan_path.file_download_path"
            :href="sowInfo.spotplan_path.file_download_path"
            traget="_blank"
          ) {{ sowInfo.spotplan_path.file_name }}
          span(v-else) —
    template(
      v-if="!sowInfo.can_edit || !isEdit"
    )
      el-row(:gutter="20" v-if="quotationData.project_path")
        el-col(:span="24")
          .info_label {{ $t('方案') }}
          .info_content
            a(
              v-if="quotationData.project_path.file_download_path"
              :href="quotationData.project_path.file_download_path"
              traget="_blank"
            ) {{ quotationData.project_path.file_name }}
      el-row(:gutter="20")
        el-col(:span="3") {{ $t('报价') }}
        el-col(:span="20")
          quotation-table(
            :hideText="true"
            :quotationData="quotationData.quotation"
          )
    template(v-else)
      el-row(:gutter="20")
        el-col.required(:span="3") {{ $t('方案') }}
        el-col(:span="10")
          div(
            :style="{ display: 'flex',alignItems: 'center' }"
          )
            new-upload-file(
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="res => uploadSuccess(res)"
            )
            uploaded-file-display(
              style="margin-left: 5px"
              class="uploaded-file-display"
              :fileName="form.file_name"
              :downloadUrl="form.file_download_path"
              width="140px"
            )
      el-row(:gutter="20")
        el-col.required(:span="3") {{ $t('报价') }}
        el-col(:span="20")
          el-button(
            style="margin-bottom: 15px"
            @click="visible = true"
          ) {{ form.quotation.total_price ? $t('修改报价明细') : $t('填写报价明细') }}
          quotation-table(
            :hideText="true"
            :quotationData="form.quotation"
          )
      el-row(:gutter="20" v-if="!alreadyHasQuotation")
        el-col(:span="10" :offset="3")
          footer-button(
            @confirm="submit"
            @cancel="$router.push('/vendor-campaign/list') "
          )
    execute-quotation-dialog(
      :visible="visible"
      v-if="visible"
      :title="$t('原始报价')"
      :data="form.quotation"
      @close="handleDialogClose"
      @confirm="handleDialogConfirm"
    )
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import QuotationTable from './QuotationTable'
import ExecuteQuotationDialog from './ExecuteQuotationDialog'
import { formatMoney, format4backend } from '@/umcc/util'
export default {
  data () {
    return {
      quotationData: {},
      loading: false,
      isEdit: true,
      alreadyHasQuotation: false,
      form: {
        file_path: '',
        file_name: '',
        file_download_path: '',
        quotation: {
          tax_total_price: null,
          total_price: null,
          quotation: [],
          tax_price: null,
          discount: null
        }
      },
      visible: false
    }
  },
  components: {
    ExecuteQuotationDialog,
    TitleBar,
    FooterButton,
    NewUploadFile,
    UploadedFileDisplay,
    QuotationTable
  },
  computed: {
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    },
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    uploadParams () {
      return {
        campaign_id: 5,
        file_type: 1
      }
    }
  },
  methods: {
    handleDialogConfirm (res) {
      this.form.quotation = res
      this.visible = false
    },
    handleDialogClose () {
      this.visible = false
    },
    getVendorQuotation () {
      this.loading = true
      axios.get('/management/star/getVendorQuotation', {
        params: {
          campaign_id: this.campaignInfo.campaign_id,
          sub_final_scope_id: this.sowInfo.sub_final_scope_id
        }
      }).then(res => {
        this.$store.commit('unistar/setSOWInfo', res)
        this.quotationData = res
        if (res.project_path.file_download_path) {
          this.alreadyHasQuotation = true
          this.isEdit = false
        } else {
          this.alreadyHasQuotation = false
          this.isEdit = true
        }
        if (res.can_edit) {
          this.form = {
            file_path: res.project_path.file_path,
            file_name: res.project_path.file_name,
            file_download_path: res.project_path.file_download_path,
            quotation: res.quotation
          }
        }
        this.loading = false
      })
    },
    uploadSuccess (res) {
      this.form.file_download_path = res.file_download_url
      this.form.file_path = res.file_path
      this.form.file_name = res.file_name
    },
    submit () {
      if (!this.form.file_path) {
        this.$message.error(this.$t('请上传方案'))
        return
      }
      if (!this.form.quotation.quotation.length) {
        this.$message.error(this.$t('请填写报价'))
        return
      }
      let params = {
        sub_final_scope_vendor_id: this.quotationData.sub_final_scope_vendor_id,
        project_path: this.form.file_path,
        vendor_star_execution_price: this.form.quotation.quotation.map(item => {
          const p = {
            star_service_id: item.star_service_id,
            unit_price: item.unit_price,
            number: item.number,
            total_price: item.total_price
          }
          if (item.star_service_item_id) {
            p.star_service_item_id = item.star_service_item_id
          }
          return p
        }),
        star_service_item: this.form.quotation.quotation.map(item => {
          return [{
            star_service_item_name: item.star_service_item_name
          }]
        }),
        vendor_star_execution_discount: {
          discount: this.form.quotation.discount
        }
      }
      this.loading = true
      axios.post('/management/star/saveVendorStarExecutionPrice', format4backend(params)).then(res => {
        this.getVendorQuotation()
        this.$message.success(this.$t('提交成功'))
        this.loading = false
      })
    },
    changeStatus () {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.submit()
    }
  },
  filters: {
    formatMoney
  },
  watch: {
    sowInfo: {
      handler (nv, ov) {
        if (nv && nv.sub_final_scope_id && (!ov || (ov && nv.sub_final_scope_id !== ov.sub_final_scope_id))) {
          this.getVendorQuotation()
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.btn_hangeStatus
  margin-left 10px
  color $main
  cursor pointer
</style>
